export interface DashboardFilter {
  startDate?: string;
  endDate?: string;
  storeId?: string;
  provider?: string;
}

/** Omits empty provider/storeId so the API matches resolver behavior (all = no param). */
export function toDashboardApiQueryParams(
  filter: DashboardFilter,
): DashboardFilter {
  return Object.fromEntries(
    Object.entries(filter).filter(
      ([, value]) => value !== undefined && value !== null && value !== "",
    ),
  );
}
